import { FormatHelper } from "../Helpers/FormatHelper.js";

export class BoxWidget {
    constructor(app, vehicle, containerElement) {
        var widget = this;
        this.app = app;
        this.vehicle = vehicle;
        this.paymentData = null;
        this.containerElement = containerElement || null;
    }

    init(paymentData) {
        paymentData = paymentData || this.paymentData;
        if(!paymentData) return;//skip        

        this.paymentData = paymentData;
        this.addHtml();
        // this.addHandlers();
    }

    addHtml(){        
        // var balloonPrice =  "$" + this.paymentData.monthly + "/Month";            
        // var balloonTerm = "For " + this.paymentData.term + " Months";

        // if (!this.paymentData.allowed) {
        //     balloonPrice = "Not available";
        //     balloonTerm = "For " + this.paymentData.term + " Months";
        // } 
        // let labelWidget = "";
        // if (this.vehicle.make == "BMW") {
        //     labelWidget = "Easy Ride";
        // } else if (this.vehicle.make == "Ducati") {
        //     labelWidget = "Premier";
        // } else {
        //     labelWidget = "Triumph Triple Financing"
        // }
        

        let isCash = this.paymentData.dealType === 'cash';
        let priceValue = isCash ? this.paymentData.payment : this.paymentData.monthlyPayment;

        let noLeaseMsgSTs = ['crystalchrysler', 'i10dodge'];
        var template = `<div class="box-widget {{class}}">
    <div class="box-title">{{title}}</div>
    <div class="offer-title"><span class="monthly-payment-value">{{monthlyPayment}}</span><span class="box-mo-suffix">/Month</span></div>
    <p class="box-details">
        <strong class="box-term-apr"><span class="apr-value">{{apr}} </span> For <span class="term-value">{{term}}</span> Months<br/></strong>
        <span class="balloon-payment-label">one single payment of </span> <span class="balloon-payment-value">{{balloonPayment}}</span><br/>
        <span class="due-at-sign-pair"><span class="due-at-sign-value">{{dueAtSign}}</span> Due at Signing<br/></span>
        <span class="down-payment-pair"><span class="down-payment-value">{{dueAtSign}}</span> Down Payment<br/></span>
        <span class="customer-cash-container d-none"><span class="customer-cash-value">{{customerCashValue}}</span> Customer Cash</span>
    </p>
    <div class="disclaimer-btn">
    </div>
    <div class='drs-tooltip'>Disclaimer <i class='pmdrs-fa pmdrs-fa-info-circle'></i>
        <span class='drs-tooltiptext-large' style="font-size: 14px;">
            {{disclaimer}}
        </span>
    </div>
    <br/>
</div>`;
        template = template
            .replaceAll("{{class}}", `bw-item-${this.paymentData.dealType}`)//bw-item-finance bw-item-lease bw-item-balloon
            // .replaceAll("{{vin}}", this.vehicle.vin)
            .replaceAll("{{dueAtSign}}", FormatHelper.currencyFormat(this.paymentData.dueAtSign, 0))
            .replaceAll("{{monthlyPayment}}", FormatHelper.currencyFormat(priceValue, 0))
            .replaceAll("{{customerCashValue}}", FormatHelper.currencyFormat(this.paymentData.customerCash ?? 0, 0))
            // .replaceAll("{{fees}}", result)
            .replaceAll("{{title}}", this.getBoxTitle())
            // .replaceAll("{{balloonPrice}}", balloonPrice)
            // .replaceAll("{{balloonTerm}}", balloonTerm)
            // .replaceAll("{{allowedClass}}", this.paymentData.allowed ? '' : 'not-allowed')
            // .replaceAll("{{msrp}}", this.paymentData.msrp)
            // .replaceAll("{{discount}}", this.paymentData.msrp - this.paymentData.final)
            .replaceAll("{{term}}", this.paymentData.term)
            .replaceAll("{{apr}}", this.paymentData.moneyFactor + "% APR ")
            // .replaceAll("{{apr}}", (this.paymentData.apr*100).toFixed(2))
            .replaceAll("{{balloonPayment}}", FormatHelper.currencyFormat(this.paymentData.balloonPayment ?? 0, 0))
            .replaceAll("{{disclaimer}}", this.paymentData.disclaimerText || this.getDefaultDisclaimer());

        const container = this.getContainerElement();
        if (!container) return;

        container.querySelectorAll('.box-widget').forEach(el => el.remove());
        container.insertAdjacentHTML("beforeend", template);
        if (this.paymentData.dealType === "lease" && noLeaseMsgSTs.includes(this.app.pmdrs.config.accountId)) {
            const lastBox = container.querySelector('.box-widget:last-child');
            lastBox.querySelector('.box-details strong').style.display = "none";
        }
        if (this.paymentData.dealType === "balloon" && this.paymentData.balloonType === "easyridecash") {
            const customerCash = container.querySelector('.customer-cash-container');
            customerCash.classList.remove('d-none');
        }
    }

    getBoxTitle(){        
        const dealType = this.paymentData.dealType;
        switch(dealType){
            case 'lease' : return 'Lease';
            case 'finance' : return 'Finance';
            case 'balloon':
                if(this.vehicle.make == "Royal Enfield") return 'Finance';//should we add another balloonType?
                if(this.vehicle.make.toLowerCase() == "harley-davidson") return 'H-D Flex';

                switch(this.paymentData.balloonType){
                    case 'easyride': return 'Easy Ride';
                    case 'easyridecash': return 'Easy Ride Cash';
                    case 'premier': return 'Premier';
                    case 'ttf': return 'Triumph Triple Financing';
                }
        }

        return dealType;
    }

    getDefaultDisclaimer(){//THIS will be gone
        return `Estimated payments exclude applicable taxes, title, registration, 
        license, and documentary fees, and will vary depending upon the final price
         and terms agreed upon between you and your dealer.`;
    }

    addHandlers() {

    }

    setContainerElement(element) {
        this.containerElement = element;
        return this;
    }

    getContainerElement() {
        if (this.containerElement) return this.containerElement;
        var containerSelector=`.${this.app.config.boxWidgetClass}[data-vin="${this.vehicle.vin}"]`;
        var containerElement = document.querySelector(containerSelector);
        if(!containerElement){
            console.error("Missing container " + containerSelector);
        }
        return containerElement;
    }
}
